import React, { useState, useEffect } from "react";
import styles from "./CreateUser.module.scss";
import { Container, Row, Col, Card, Button, Form, Tab, Modal, InputGroup, FormControl } from "react-bootstrap";
import UserForm from "./UserForm";
import { t } from "i18next";
import UserTabs from "./UserTabs";
import PermissionsTabContent from "./PermissionsTabContent";
import ReportPreferenceTabContent from "./ReportPreference"
import { Toast, ToastContainer } from "react-bootstrap";
import DataManager from "../../../General/DataManager";
import UserClass from "../../../General/LocalStorage/UserClass";
import Functions from "../../../General/Functions";
import { UserStatus } from "../../../config/constants";



const generatePassword = () => {
  return Math.floor(10000 + Math.random() * 90000).toString();
};




const CreateUser = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    phoneCountryCode: "+39",
    phoneNumber: "",
    role: "",
    status: UserStatus.ACTIVE,
    password: generatePassword(),
    companies: []
  });

  const [selectedPorts, setSelectedPorts] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [saveProgress, setSaveProgress] = useState(0);
  const [saveError, setSaveError] = useState(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [copied, setCopied] = useState(false);
  const [errors, setErrors] = useState({});
  const [activeTab, setActiveTab] = useState("profile");
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [ports, setPorts] = useState([]);
  const [portsError, setPortsError] = useState(null);
  const [isLoadingPorts, setIsLoadingPorts] = useState(false);
  const [roles, setRoles] = useState([]);
  const [isLoadingRoles, setIsLoadingRoles] = useState(false);
  const [rolesError, setRolesError] = useState(null);

  //handle reports
  const [isLoadingReportTypes, setIsLoadingReportTypes] = useState(false);
  const [reportTypesError, setReportTypesError] = useState(null);
  const [reportTypes, setReportTypes] = useState([]);
  const [selectedReportTypes, setSelectedReportTypes] = useState([]);




  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      document.querySelector(".is-invalid")?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [errors]);

  useEffect(() => {
    getCompanies();
    getRoles();
    getReportTypes();
  }, []);





  const handleChange = (e) => {

    const { name, value } = e.target;

    let finalValue = value;

    if (name === "defaultSending") {
      finalValue = e.target.checked;
    }

    if (name === "companies") {

      finalValue = value ? value?.map(v => v.value) : [];

      if (form.role === "BOARDING_OPERATOR" && finalValue.length > 1) {
        setErrors(prev => ({
          ...prev,
          companies: t('error_boarding_operator_one_company')
        }));
        return;
      }
    }

    if (name === "role") {
      if (
        value === "BOARDING_OPERATOR" &&
        form.companies.length > 1
      ) {
        setErrors(prev => ({
          ...prev,
          companies: t('error_boarding_operator_one_company')
        }));
        return;

      }
    }

    setForm(prev => ({
      ...prev,
      ...(name === "email" ? { email: finalValue, username: finalValue } : { [name]: finalValue })
    }));

    if (name === "companies" || name === "role") {

      if ((finalValue && finalValue.length > 0) || finalValue !== "") {

        setErrors(prev => {
          const newErrors = { ...prev };

          if ("companies" in newErrors) {
            delete newErrors["companies"];
          }

          return newErrors;
        });
      }
    }
    else {
      if (typeof finalValue === "string" && finalValue?.trim() !== "") {
        setErrors(prev => {
          const newErrors = { ...prev };

          if (name in newErrors) {
            delete newErrors[name];
          }

          return newErrors;
        });
      }
    }
    if (name === "companies") {
      setPorts([]);
      setSelectedPorts([]);
      if (finalValue?.length === 1) {
        getPorts(finalValue[0]);
      }
    }


  }


  const getPorts = async (company) => {
    setIsLoadingPorts(true);
    setPortsError(null);

    try {
      const instance = UserClass.getInstance();
      const token = instance.getTokenUser();

      const { ports, msgError } = await DataManager.getPorts(company, token);


      if (msgError) {
        throw new Error(msgError);
      }

      setPorts(ports["results"] ?? []);
    } catch (error) {
      setPorts([]);
      setPortsError(error.message || t("msgErrorGeneral"));
    } finally {
      setIsLoadingPorts(false);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = Functions.validateUserForm(form, selectedPorts);

    console.log(validationErrors)

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSaveError(null);
    setErrors({});
    setShowModal(true);
  };

  const handleCancel = (e) => {
    setShowModalCancel(true)
  }
  const getCompanies = () => {
    let instance = UserClass.getInstance();
    let token = instance.getTokenUser();

    DataManager.verifyLogin
      (token).then((result) => {
        if (typeof (result) !== 'undefined' && result !== null) {
          if (typeof (result['verifylogin']) !== 'undefined' && result['verifylogin'] !== null) {

            setCompanies(result['verifylogin']['companies'])
          } else {
            if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
              Functions.alertMsg(result['msgError']);
            } else {
              Functions.alertMsg(t("msgErrorGeneral"));
            }
          }
        } else {
          Functions.alertMsg(t("msgErrorGeneral"));
        }
      });
  }

  const getRoles = async () => {

    setIsLoadingRoles(true);
    setRolesError(null);

    try {
      const instance = UserClass.getInstance();
      const token = instance.getTokenUser();

      const { data, msgError } = await DataManager.getRoles(token);



      if (msgError) {
        throw new Error(msgError);
      }

      setRoles(data);
    } catch (error) {
      setRoles([]);
      setRolesError(error.message || t("msgErrorGeneral"));
    } finally {
      setIsLoadingRoles(false);
    }

  }

  const getReportTypes = async () => {

    setIsLoadingReportTypes(true);
    setReportTypesError(null);

    try {
      const instance = UserClass.getInstance();
      const token = instance.getTokenUser();

      const { data, msgError } = await DataManager.getReportTypes(token);

      console.log("getReportTypes ", data);

      if (msgError) {
        throw new Error(msgError);
      }

      setReportTypes(data);
    } catch (error) {
      setReportTypes([]);
      setReportTypesError(error.message || t("msgErrorGeneral"));
    } finally {
      setIsLoadingReportTypes(false);
    }

  }

  const handleConfirm = async () => {
    setIsSaving(true);
    setSaveProgress(20);
    setSaveError(null);


    const normalizedPhoneNumber = `${form.phoneCountryCode}${form.phoneNumber}`.replace(/\s+/g, "");


    const payload = {
      ...form,
      phoneNumber: normalizedPhoneNumber,
      ports: selectedPorts,
      reports: selectedReportTypes
    };

    delete payload.phoneCountryCode;
    delete payload.username;

    if (payload.role !== 'BOARDING_OPERATOR') {
      delete payload.ports;

    }


    let progressInterval;

    try {
      // Smooth progress animation
      progressInterval = setInterval(() => {
        setSaveProgress((prev) => Math.min(prev + 10, 90));
      }, 300);

      const instance = UserClass.getInstance();
      const token = instance.getTokenUser();

      const { data, msgError } = await DataManager.createUser(token, payload);

      clearInterval(progressInterval);

      if (msgError) {
        setSaveError(msgError);
        setSaveProgress(100);
        return;
      }

      // Success
      setSaveProgress(100);

      setTimeout(() => {
        setShowModal(false);
        setShowSuccessToast(true);
      }, 300);

      setTimeout(() => {
        window.location.href = "/pages/UserManagement/";
      }, 2500);

    } catch (err) {
      clearInterval(progressInterval);
      console.error(err);
      setSaveError(t("user_creation_failed"));
      setSaveProgress(100);
    } finally {
      setIsSaving(false);
    }
  };



  const togglePort = (portId) => {
    setSelectedPorts((prev) => {
      const updatedPorts = prev.includes(portId)
        ? prev.filter((id) => id !== portId)
        : [...prev, portId];

      // Clear ports error if at least one port is selected
      if (updatedPorts.length > 0) {
        setErrors((prevErrors) => {
          if (!prevErrors.ports) return prevErrors;

          const newErrors = { ...prevErrors };
          delete newErrors.ports;
          return newErrors;
        });
      }

      return updatedPorts;
    });
  };

  const toggleReportType = (id) => {

    setSelectedReportTypes((prev) => {
      const exists = prev.find(r => r.id === id);

      if (exists) {
        // removing report
        return prev.filter(r => r.id !== id);
      }

      // adding report
      return [
        ...prev,
        { id: id, defaultSending: false, appearInSendingList: false }
      ];
    });
  };

  const toggleDefaultSending = (id) => {
    setSelectedReportTypes((prev) =>
      prev.map((r) =>
        r.id === id
          ? { ...r, defaultSending: !r.defaultSending }
          : r
      )
    );
  };

  const toggleAppearInSendingList = (id) => {
    setSelectedReportTypes((prev) =>
      prev.map((r) =>
        r.id === id
          ? { ...r, appearInSendingList: !r.appearInSendingList}
          : r
      )
    );
  }


  const copyToClipboard = (text) => {
    navigator?.clipboard?.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCancelCreation = () => {
    window.location.href = "/pages/UserManagement/";
  }

  return (
    <>
      <div className={styles.CreateUser}>
        <Container fluid="md">
          {/* Header */}
          <Row className="mb-4 align-items-center">
            <Col>
              <h2 className={styles.title}>{t("create_user")}</h2>
              <div className={styles.subtitle}>{t("create_user_description")}</div>
            </Col>
            <Col xs="auto">
              <Button variant="secondary" className="me-2" onClick={handleCancel}>
                {t("cancel")}
              </Button>
              <Button variant="primary" onClick={handleSubmit} disabled={showModal}>
                {t("save")}
              </Button>
            </Col>
          </Row>

          <Tab.Container defaultActiveKey="profile" onSelect={(k) => setActiveTab(k)}>
            <UserTabs activeKey="profile" showSecurity={false} showPermissions={form.role === "BOARDING_OPERATOR"} />
            <Tab.Content>
              {(errors?.ports && form.role === "BOARDING_OPERATOR") && (
                <div className="alert alert-warning py-2">
                  {activeTab !== "permissions" ? t('set_at_least_one_port_required_in_permissions') : errors.ports}
                </div>
              )}

              <Tab.Pane eventKey="profile">
                <UserForm
                  form={form}
                  errors={errors}
                  roles={roles}
                  companies={companies}
                  onChange={handleChange}
                  onSubmit={handleSubmit}
                  onRegeneratePassword={() =>
                    setForm({ ...form, password: generatePassword() })
                  }
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                />
              </Tab.Pane>
              <ReportPreferenceTabContent
                reportTypes={reportTypes}
                onChange={handleChange}
                form={form}
                selectedReportTypes={selectedReportTypes}
                toggleReportType={toggleReportType}
                toggleDefaultSending={toggleDefaultSending}
                toggleAppearInSendingList={toggleAppearInSendingList}
                errors={errors}
              />
              {
                form.role === "BOARDING_OPERATOR" && (
                  <PermissionsTabContent
                    ports={ports}
                    selectedPorts={selectedPorts}
                    togglePort={togglePort}
                    errors={errors}

                  />
                )
              }
            </Tab.Content>
          </Tab.Container>

          {/* Modal */}
          <Modal
            show={showModal}
            onHide={() => !isSaving && setShowModal(false)}
            backdrop={isSaving ? "static" : true}
            keyboard={!isSaving}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("confirm_user_creation")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                {t("please_save_credentials")}:
              </p>
              <div className="mb-3">
                <strong>{t("username")}: </strong> {form.username}
              </div>
              <InputGroup className="mb-3">
                <FormControl
                  value={form.password}
                  readOnly
                  style={{ fontWeight: "bold" }}
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => copyToClipboard(form.password)}
                >
                  {t("copy")}
                </Button>
              </InputGroup>
              {copied && (
                <small className="text-success d-block mt-1">
                  ✓ {t("copied_to_clipboard")}
                </small>
              )}

              <p className="text-warning">
                ⚠️ {t("password_only_shown_once")}
              </p>
              {isSaving && (
                <div className="mt-3">
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className={`progress-bar progress-bar-striped progress-bar-animated ${saveError ? "bg-danger" : ""
                        }`}
                      style={{ width: `${saveProgress}%` }}
                    />
                  </div>
                  <small className="text-muted mt-2 d-block">
                    {t("saving_user")}
                  </small>
                </div>
              )}

              {saveError && (
                <div className="alert alert-danger py-2">
                  {saveError}
                </div>
              )}

            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowModal(false)}
                disabled={isSaving}
              >
                {t("close")}
              </Button>

              <Button
                variant="primary"
                onClick={handleConfirm}
                disabled={isSaving}
              >
                {isSaving ? t("saving") : t("confirm_and_save")}
              </Button>
            </Modal.Footer>


          </Modal>

          {/* Cancel Confirmation Modal */}
          <Modal
            show={showModalCancel}
            onHide={() => !isSaving && setShowModalCancel(false)}
            backdrop={isSaving ? "static" : true}
            keyboard={!isSaving}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("cancel_user_creation")}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p className="mb-2">
                {t("are_you_sure_you_want_to_cancel")}
              </p>

              <p className="text-danger mb-0">
                ⚠️ {t("all_inserted_information_will_be_discarded")}
              </p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowModalCancel(false)}
                disabled={isSaving}
              >
                {t("go_back")}
              </Button>

              <Button
                variant="danger"
                onClick={handleCancelCreation}
                disabled={isSaving}
              >
                {t("yes_cancel")}
              </Button>
            </Modal.Footer>
          </Modal>

        </Container>
      </div>
      <ToastContainer
        position="top-center"
        className="p-3"
        style={{ position: "fixed", marginTop: "70px", zIndex: 2000 }}
      >
        <Toast
          show={showSuccessToast}
          bg="success"
          delay={3000}
          autohide
          onClose={() => setShowSuccessToast(false)}
        >
          <Toast.Header closeButton={false}>
            <strong className="me-auto">{t("success")}</strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            {t("user_created_successfully")}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default CreateUser;
